import { ReactNode, type PropsWithChildren } from 'react';
import { HelpToggletip, TipPlacement } from 'ui/tooltip';
import { RadioField } from 'lib/iterable-hook-form/FormField/RadioField';
import { RadioRow, RadioRowDisabledTooltip, RadioRowText } from './EditableConversion.styles';
import { AttributionMode } from 'modules/domains/campaign';

type AttributionRowProps = PropsWithChildren<{
  name: string;
  attributionMode: AttributionMode;
  text: JSX.Element | string;
  tooltip?: string;
  isDisabled?: boolean;
  disabledTooltipContent?: ReactNode;
}>;

export const AttributionRow = ({
  name,
  attributionMode,
  text,
  tooltip,
  children,
  isDisabled = false,
  disabledTooltipContent,
}: AttributionRowProps) => {
  const isDisabledWithTooltip = !!(isDisabled && disabledTooltipContent);

  return (
    <RadioRow>
      <RadioRowDisabledTooltip
        isEnabled={isDisabledWithTooltip}
        tooltipContent={disabledTooltipContent}
      >
        <div>
          <RadioField isDisabled={isDisabled} name={name} radioKey={attributionMode} />
        </div>
        <div>
          <RadioRowText $isDisabled={isDisabled}>{text}</RadioRowText> {children}
        </div>
      </RadioRowDisabledTooltip>

      {tooltip && <HelpToggletip placement={TipPlacement.Bottom} tooltipContent={tooltip} />}
    </RadioRow>
  );
};
